var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 17.749,
    viewBox: "0 0 24 17.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M5.243,15.267a21.58,21.58,0,0,1-3.337-2.919V12.5l-1.2-1.556a3.393,3.393,0,0,1,0-4.143A21.817,21.817,0,0,1,5.243,2.482,11.893,11.893,0,0,1,12,0a11.9,11.9,0,0,1,6.757,2.482A21.852,21.852,0,0,1,23.294,6.8a3.39,3.39,0,0,1,0,4.143,21.764,21.764,0,0,1-4.538,4.321A11.893,11.893,0,0,1,12,17.749,11.893,11.893,0,0,1,5.243,15.267ZM6.36,4.306A19.888,19.888,0,0,0,2.386,8.1a1.268,1.268,0,0,0,0,1.552A20.041,20.041,0,0,0,6.36,13.443,10.1,10.1,0,0,0,12,15.628a10.1,10.1,0,0,0,5.64-2.184,19.889,19.889,0,0,0,3.974-3.793,1.271,1.271,0,0,0,0-1.553A19.888,19.888,0,0,0,17.64,4.306,10.1,10.1,0,0,0,12,2.121,10.1,10.1,0,0,0,6.36,4.306ZM12,14.623a5.749,5.749,0,1,1,4.066-1.684A5.714,5.714,0,0,1,12,14.623ZM9.437,6.311A3.623,3.623,0,1,0,12,5.246,3.605,3.605,0,0,0,9.437,6.311Zm2.077.968a1.06,1.06,0,1,1,1.06,1.06A1.061,1.061,0,0,1,11.514,7.278Z",
    transform: "translate(3 6)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(-3 -6)",
    fill: "#47d5cd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M5.243,15.267a21.58,21.58,0,0,1-3.337-2.919V12.5l-1.2-1.556a3.393,3.393,0,0,1,0-4.143A21.817,21.817,0,0,1,5.243,2.482,11.893,11.893,0,0,1,12,0a11.9,11.9,0,0,1,6.757,2.482A21.852,21.852,0,0,1,23.294,6.8a3.39,3.39,0,0,1,0,4.143,21.764,21.764,0,0,1-4.538,4.321A11.893,11.893,0,0,1,12,17.749,11.893,11.893,0,0,1,5.243,15.267ZM6.36,4.306A19.888,19.888,0,0,0,2.386,8.1a1.268,1.268,0,0,0,0,1.552A20.041,20.041,0,0,0,6.36,13.443,10.1,10.1,0,0,0,12,15.628a10.1,10.1,0,0,0,5.64-2.184,19.889,19.889,0,0,0,3.974-3.793,1.271,1.271,0,0,0,0-1.553A19.888,19.888,0,0,0,17.64,4.306,10.1,10.1,0,0,0,12,2.121,10.1,10.1,0,0,0,6.36,4.306ZM12,14.623a5.749,5.749,0,1,1,4.066-1.684A5.714,5.714,0,0,1,12,14.623ZM9.437,6.311A3.623,3.623,0,1,0,12,5.246,3.605,3.605,0,0,0,9.437,6.311Zm2.077.968a1.06,1.06,0,1,1,1.06,1.06A1.061,1.061,0,0,1,11.514,7.278Z",
    transform: "translate(3 6)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.952a0003f1a3c2916017d4b1b66435fd.svg";
export { ForwardRef as ReactComponent };